<template>
  <v-card flat class="pa-4">
    <v-switch v-model="preferences.blendDuration" label="Track duration" dense/>
    <v-switch v-model="preferences.blendIncomplete" label="Allow incomplete blends" dense/>
    <v-switch v-model="preferences.blendLot" label="Allow lot of output spirit to be specified" dense/>
    <v-row dense class="mt-4">
      <v-col cols="3 pt-3">Numbering</v-col>
      <v-col cols="3">
        <v-text-field label="Prefix" v-model="preferences.numberPrefix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <v-text-field label="Suffix" v-model="preferences.numberSuffix" :rules="[fieldRules.maxLength(10)]" outlined dense :counter="10"/>
      </v-col>
      <v-col cols="3">
        <decimal-number-input label="Start at" v-model="preferences.numberStart" :precision="0" integer prefix=""/>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'ProductionBlendingPreferences',
  data() {
    return {
      preferences: {}
    }
  },
  watch: {
    preferences: {
      async handler() {
        const results = await this.$apiCall(`mutation ProductionBlendingPreferences($input:BlendingPreferencesInput!) {
                                              blendingSetPreferences(input:$input) {
                                                blendDuration, blendIncomplete, blendLot
                                                numberPrefix, numberSuffix, numberStart
                                              }
                                            }`,
                                            {input:this.preferences});
        if (!results.error)
          this.$emit('update', results.data.blendingSetPreferences)
      },
      immediate: false,
      deep: true
    }
  },
  async created() {
    const results = await this.$apiCall(`query ProductionBlendingPreferences {
                                          blendingPreferences {
                                            blendDuration, blendIncomplete, blendLot
                                            numberPrefix, numberSuffix, numberStart
                                          }
                                        }`,
                                        {});
    if (!results.error)
      this.preferences = results.data.blendingPreferences;
  }
}
</script>